import {DRMTypes, isEdge} from "./webservice";
import {getServerEndPoint} from "../liveshows/webEndPoint";
import axios from "axios";
import {isChromiumEdgeMac, isPlayStationBrowser, isWindowEdge, isSafari} from "./utils";
import config from "../config/config";

const getLicence = async () =>{

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        let apiGetWay
        if(isWindowEdge()){
            apiGetWay =   getServerEndPoint() +  "api/actual_location_licence"
        }
        else if(isSafari()){
            apiGetWay =   getServerEndPoint() +  "api/actual_location_iso_licence"
        }
        else if(isChromiumEdgeMac()){
            apiGetWay =   getServerEndPoint() + "api/actual_location";
        }
        else {
            apiGetWay =   getServerEndPoint() +  "api/actual_location";
        }
        const licencesData = await axios.get(apiGetWay);
        return licencesData?.data
    }
    else {
        if(isWindowEdge()){
            return    config.licence+   getServerEndPoint() + "licence/GetLicenceWindowFairePlay"
        }
        else if(isSafari()){
            return   config.licence +   getServerEndPoint() + "licence/GetLicenceIsoFairePlay"
        }
        else if(isChromiumEdgeMac()){
            return  config.licence + getServerEndPoint() + "licence/GetLicenceWidevine"
        }
        else if(isPlayStationBrowser()){
            return   getServerEndPoint() + "licence/GetLicenceWindowFairePlay"
        }
        return    config.licence +  getServerEndPoint() + "licence/GetLicenceWidevine"
    }


}

const configELDGEWindow = (serverCertificate, certificate, licences) => {

    return {
        fallbackEpgId: 480,
        referenceDateTime: 1370044800,
        drm: {
            certificates: certificate
        },
        deviceId: "2",
        drmId: 31,
        drmEnv: "widevine",
        service: "mycanal",
        deviceType: "web",
        drmNeeded: true,
        keySystem: "com.widevine.alpha",
        supportedDrms: [
            {
                keySystem: "com.widevine.alpha",
                name: "widevine",
                robustnesses: [
                    "SW_SECURE_DECODE",
                    "SW_SECURE_CRYPTO"
                ],
                securityLevel: "L3"
            }
        ],
        securityLevel: "L3",
        offerLocation: "fr",
        offerZone: 'cpfra',
        deviceInfo: null,
        maxCompatibleVideoOutput: null,
        drmCertificate: serverCertificate,
        licence: licences,
        keyPerLicense: "mkpl"
    }
}

const configsOther = (serverCertificate, certificate, licence) => {
    return {
        supportedDrms:
            [
                {
                    keySystem: "com.widevine.alpha",
                    name: "widevine",
                    robustnesses: [
                        "SW_SECURE_DECODE",
                        "SW_SECURE_CRYPTO"
                    ],
                    securityLevel: "L3",

                }
            ]
        ,
        drmEnv: "widevine",
        drmNeeded: true,
        keySystem: "com.widevine.alpha",
        drm: {
            certificates: certificate
        },
        drmCertificate: serverCertificate,
        offerLocation: "fr",
        deviceType: "web",
        offerZone: "cfa",
        keyPerLicense: "mkpl",
        shouldPersistLicense: 'com.widevine.alpha',
        name: DRMTypes.WIDEVINE,
        licence: licence,
        maxLiveSessionInMinutes: 360,
        liveTvGroupType: {
            cpfra: "1;2;4",
            cpafr: "1",
        },
        fallbackEpgId: 480,
        securityLevel: null,
        referenceDateTime : 1370044800

    }
}

const configsPlaystation = (serverCertificate, certificate, licence) => {
    return {
        supportedDrms: [
            {
                keySystem: "com.microsoft.playready",
                name: "playready",
                robustnesses: [],
                canPersistLicense: false
            },
            {
                keySystem: "com.microsoft.playready.recommendation.3000",
                name: "playready",
                robustnesses: [],
                canPersistLicense: true
            },
            {
                keySystem: "com.microsoft.playready.recommendation",
                name: "playready",
                robustnesses: [
                    "3000",
                    "2000"
                ],
                canPersistLicense: true
            },
            {
                keySystem: "com.microsoft.playready.recommendation.2000",
                name: "playready",
                robustnesses: [],
                canPersistLicense: true
            },
            {
                keySystem: "com.microsoft.playready.hardware",
                name: "playready",
                robustnesses: [],
                canPersistLicense: false
            },
            {
                keySystem: "com.microsoft.playready.software",
                name: "playready",
                robustnesses: [],
                canPersistLicense: false
            }
        ],
        drmEnv: "playready",
        drmNeeded: true,
        keySystem: "com.microsoft.playready.recommendation",
        drm: {
            certificates: certificate
        },
        reload: {
            enableOnFatalError: true,
            maxCountdownStart: 15000,
            minCountdownStart: 5000
        },
        drmCertificate: serverCertificate,
        offerLocation: "fr",
        deviceType: "web",
        offerZone: "cfa",
        keyPerLicense: "mkpl",
        shouldPersistLicense: true,
        name: DRMTypes.FAIRPLAY,
        licence: licence,
        maxLiveSessionInMinutes: 360,
        liveTvGroupType: {
            cpfra: "1;2;4",
            cppol: "1;2;4",
            cpche: "1",
            cpafr: "1",
        },
        fallbackEpgId: 480,
        securityLevel: null,
        referenceDateTime : Date.now()

    }
}

const configsMacSafari = (serverCertificate, certificate, licence) => {
    return {
        supportedDrms:
            [
                {
                    keySystem: "com.apple.fps.1_0",
                    name: "fairplay",
                    canPersistLicense: false,
                    robustnesses: [
                        "HW_SECURE_ALL",
                        "HW_SECURE_DECODE",
                        "HW_SECURE_CRYPTO"

                    ],
                    securityLevel: null,

                },
            ]
        ,
        drmEnv: "fairplay",
        drmNeeded: true,
        keySystem: "com.apple.fps.1_0",
        drm: {
            certificates: certificate
        },
        drmCertificate: serverCertificate,
        offerLocation: "fr",
        deviceType: "web",
        offerZone: "cfa",
        keyPerLicense: "mkpl",
        shouldPersistLicense: true,
        name: DRMTypes.FAIRPLAY,
        licence: licence,
        maxLiveSessionInMinutes: 360,
        liveTvGroupType: {
            cpfra: "1;2;4",
            cppol: "1;2;4",
            cpche: "1",
            cpafr: "1",
        },
        fallbackEpgId: 480,
        securityLevel: null,
        referenceDateTime : Date.now()

    }
}


const getConfigsDrm = (serverCertificate, certificate, licence ) => {

    if(isEdge()) {
        return configELDGEWindow(serverCertificate, certificate, licence)
    }
    else if (isSafari()){
        return  configsMacSafari(serverCertificate, certificate, licence)
    }
    else if(isPlayStationBrowser()){
        return configsPlaystation(serverCertificate, certificate, licence)
    }
    return  configsOther(serverCertificate, certificate, licence)

}
export { getConfigsDrm, getLicence, isSafari}
